var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMillustrationsEks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 40,
  fill: "none",
  viewBox: "0 0 56 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 23,
  x: 8.5,
  y: 8.5,
  fill: "#fff",
  stroke: "#CCCCD9",
  rx: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#8A8A99",
  fillRule: "evenodd",
  d: "m28.27 23.756 2.817-1.634a.15.15 0 0 1 .155 0l2.515 1.458c.103.06.103.21 0 .27l-5.488 3.184a.15.15 0 0 1-.155 0l-6.036-3.502a.16.16 0 0 1-.078-.135v-7.003c0-.055.03-.107.078-.135l5.487-3.183a.156.156 0 0 1 .233.135v2.917c0 .056-.03.107-.077.135l-2.818 1.635a.16.16 0 0 0-.078.135v3.725c0 .056.03.107.078.135l3.21 1.863a.15.15 0 0 0 .156 0m.392-7.492 2.818 1.634c.048.028.077.08.077.136v3.268c0 .056.03.108.078.136l2.515 1.458a.155.155 0 0 0 .233-.135v-6.366a.16.16 0 0 0-.078-.136l-5.487-3.183a.156.156 0 0 0-.234.135v2.918c0 .055.03.107.078.135M26.87 17.86h.572v1.696l1.648-1.696h.755l-1.808 1.869 1.922 2.155h-.732l-1.785-2.012v2.012h-.572z",
  clipRule: "evenodd"
})));
export default SvgMillustrationsEks;